import script from "./OrderMobileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderMobileCard.vue?vue&type=script&setup=true&lang=js"

import "./OrderMobileCard.vue?vue&type=style&index=0&id=d0725a98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0725a98"]])

export default __exports__